module.exports = __webpack_public_path__ + "media/assets/images/blog/inbox-zero-small-99001d6f6e63baad44a11dea178b63ee.png";